// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/artifact.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * Represents a large immutable blob of data.
 *
 * @generated from message ai.h2o.storage.Artifact
 */
export const Artifact = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Artifact",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "state", kind: "enum", T: proto3.getEnumType(Artifact_ArtifactState) },
    { no: 5, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "md5_digest", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "created_time", kind: "message", T: Timestamp },
    { no: 8, name: "uploaded_time", kind: "message", T: Timestamp },
    { no: 10, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "last_modified_time", kind: "message", T: Timestamp },
  ],
);

/**
 * State of the artifact. This only considers how the ArtifactService sees the
 * artifact and not
 * the underlying storage system. As a result, the artifact may be in the
 * state AVAILABLE but
 * already manually deleted form the underlying S3 storage. Download request
 * for such an artifact
 * will fail.
 *
 * @generated from enum ai.h2o.storage.Artifact.ArtifactState
 */
export const Artifact_ArtifactState = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.storage.Artifact.ArtifactState",
  [
    {no: 0, name: "UNKNOWN_ARTIFACT_STATE"},
    {no: 1, name: "AVAILABLE"},
    {no: 2, name: "DELETED"},
    {no: 3, name: "BEING_UPLOADED"},
    {no: 4, name: "UPLOAD_FAILED"},
    {no: 5, name: "EMPTY"},
  ],
);

